import MCLib from '../static/js/mc-lib';
import getStackUrl from './getStackUrl';

const LOGOUT_PATH = '/stargate/sso/mc/logout';

const mcLib = new MCLib({ allowedOrigin: getStackUrl(), mc: window.top });

mcLib.registerLogoutUrl(window.location.origin + LOGOUT_PATH);

export default mcLib;
